import React from 'react'
import PropTypes from 'prop-types'

import Footer from './footer/footer'
import Navbar from './nav/navbar'

// For shared styles.
import './layout.scss'
import './pagelayout.scss'

const PageLayout = ({ mainClassName, children }) => {
  return (
    <div className="page-container">
      <Navbar />
      <main className="page-content">{children}</main>
      <Footer />
    </div>
  )
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PageLayout
